export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS='LOGIN_SUCCESS';
export const LOGIN_FAILURE='LOGIN_FAILURE';
export const LOGOUT='LOGOUT';

export const login = (data) => {
    return {
        type: LOGIN,
        data
    }
}
export const loginSuccess = (data) => {
    return {
        type: LOGIN_SUCCESS,
        data
    }
}
export const loginFailure = (data) => {
    return {
        type: LOGIN_FAILURE,
        data
    }
}

export const SET_USER_DETAILS = 'SET_USER_DETAILS';
export const  setUserDetails = (data) => {
    return {
        type: SET_USER_DETAILS,
        data
    }
}

export const logout = () => {
  return {
    type:LOGOUT
  }
}